import React from 'react';
import { Form } from 'antd';

import { RadioCards } from '@/components/ui/Inputs/RadioCards';
import { Container } from './styles';

import { WORK_CONDITIONS } from '../../enum';

export const WorkConditions = () => {
	return (
		<Container>
			<Form.Item
				name="work_conditions"
				rules={[
					{
						required: true,
						message: 'Invalid'
					}
				]}
				style={{ margin: 0 }}
				valuePropName="checked"
			>
				<RadioCards
					name="work_conditions"
					cardType="vertical"
					direction="column"
					cards={WORK_CONDITIONS}
				/>
			</Form.Item>
		</Container>
	);
};
